<template>
  <nav class="navbar is-light">
    <div class="navbar-brand">
      <!-- <a class="navbar-item" href=""> -->
      <img width="250px" src="../assets/images/filedoc-01.png"/>

      <!-- </a> -->
      <div
        @click="toggleNav = !toggleNav"
        class="navbar-burger burger"
        data-target="navbarExampleTransparentExample"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div
      id="navbarExampleTransparentExample"
      class="navbar-menu"
      :class="{ 'is-active': toggleNav }"
    >
      <div class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable">
          <!--<a class="navbar-link" href="/documentation/overview/start/">-->
          <!--Docs-->
          <!--</a>-->
          <div class="navbar-dropdown is-boxed">
            <router-link
              v-if="isAccess('FBA')"
              :to="{ name: 'home.consulta' }"
              class="navbar-item"
            >
              Búsqueda por archivo
            </router-link>

            <router-link
              v-if="isAccess('FBC')"
              :to="{ name: 'home.consultaPorCaja' }"
              class="navbar-item"
            >
              Búsqueda por caja
            </router-link>

            <hr class="navbar-divider"/>

            <router-link
              v-if="isAccess('FP')"
              :to="{ name: 'home.pedidos' }"
              class="navbar-item"
            >
              Pedidos
            </router-link>
            <router-link
              v-if="isAccess('FR')"
              :to="{ name: 'home.recojos' }"
              class="navbar-item"
            >
              Recojos
            </router-link>
            <router-link
              v-if="isAccess('FD')"
              :to="{ name: 'home.digitalizacion' }"
              class="navbar-item"
            >
              Digitalización
            </router-link>

            <hr class="navbar-divider"/>
            <router-link
              v-if="isAccess('FRP')"
              :to="{ name: 'home.reporte-pedidos' }"
              class="navbar-item"
            >
              Reporte de pedidos
            </router-link>
            <router-link
              :to="{ name: 'home.reporte-files' }"
              class="navbar-item"
            >
              Reporte de ingresos
            </router-link>
          </div>
        </div>

        <!--
        <div class="navbar-item item-contenedor-busqueda">
          <b-field class="field-busqueda" position="is-centered">
            <b-input :placeholder="placeholderSearchField" @keydown.native.13="buscarFile" ref="inputBusqueda" @input="onChangeTextSearch" v-model="textSearch" @focus="goConsulta"  expanded type="number" icon="magnify">
            </b-input>
            <p class="control">
              <b-tooltip label="Ingrese un mínimo de 3 caracteres"
                         position="is-bottom"
                         :active="mensajeBuscar"
                          :always="true">
                <button @click="buscarFile" class="button is-info">Buscar</button>
              </b-tooltip>

            </p>
          </b-field>
        </div>-->
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="field is-grouped">
            <p class="control">
              <button @click="showCar" class="bd-tw-button button">
                <b-icon icon="cart" size="is-small"></b-icon>
                <span> Carrito ({{ carlength }}) </span>
              </button>
            </p>
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <div class="navbar-link">
            <span>{{ username }}</span>
          </div>
          <div class="navbar-dropdown is-boxed">
            <!--<hr class="navbar-divider">-->
            <a @click="goLogout" class="navbar-item"> Salir </a>
            <router-link :to="{ name: 'home.perfil' }" class="navbar-item">
              Mi perfil
            </router-link>
            <router-link
              :to="{ name: 'home.cambiar-clave' }"
              class="navbar-item"
            >
              Cambiar clave
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Util from "../util";
import Carrito from "../components/Carrito";

export default {
  name: "app",
  data() {
    return {
      toggleNav: false,
      //mensajeBuscar:false,
      username: "",
      nameClient: "",
    };
  },
  methods: {
    ...mapActions({logout: "auth/logout"}),
    //...mapActions({'changeTextSearch': 'search/changeTextSearch', 'search': 'search/search'}),
    //...mapActions({'setFiles': 'files/setFiles'}),
    //...mapActions({'setBoxes': 'boxes/setBoxes'}),
    goLogout() {
      this.logout({context: this}).then();
    },
    /*goConsulta(){
        this.$router.push({name: 'home.consultaPorCaja'})
      },*/
    showCar() {
      this.$modal.open({
        parent: this,
        component: Carrito,
        width: 700,
      });
    },
    /*buscarFile(){

        if(this.validateTextSearch)
        {
          this.$eventHub.$emit('search');
        }

        else {
          this.mensajeBuscar=true
          setTimeout(()=> this.mensajeBuscar=false, 3000);
        }

      },
      onChangeTextSearch(){
        if(this.getTextSearch.length==0 && this.getIsSearch && !this.getIsSearchAdvanced)
        {
          //this.setFiles({files:[]})
          this.setBoxes({boxes:[]})
        }

      },
      focusBusqueda(){
        console.log("Entro")
        this.$refs.inputBusqueda.focus()
      }*/
    isAccess(access) {
      let usuarioLogueado = Util.getUser();
      if (usuarioLogueado.access) {
        if (usuarioLogueado.access.length > 0) {
          return usuarioLogueado.access.find((a) => a === access);
        } else {
          return this.getClient.access.find((a) => a === access);
        }
      } else {
        return this.getClient.access.find((a) => a === access);
      }
      //return this.getClient.access.find((a) => a === access);
    },
  },
  computed: {
    //...mapGetters({'getIsSearch':'search/getIsSearch', 'getTextSearch':'search/getTextSearch'}),
    ...mapGetters({getCar: "car/getCar"}),
    ...mapGetters({getClient: "auth/getClient"}),
    //...mapGetters({'getIsSearchAdvanced':'search/getIsSearchAdvanced'}),
    /*textSearch: {
        get () {
          return this.getTextSearch
        },
        set (value) {
          this.changeTextSearch(value)
        }
      },
      validateTextSearch(){
        return this.getTextSearch.length>=3
      },*/
    carlength() {
      return this.getCar.length;
      /*},
      placeholderSearchField(){
        return "Ingresa un número de caja..."
      }*/
    },
  },

  created() {
    //this.$eventHub.$on('focusTextSearch', this.focusBusqueda);
    //this.$eventHub.$on(this.focusBusqueda);

    if (!Util.getAuth() || !Util.getClient()) {
      localStorage.clear();
      this.$router.push({name: "login"});
    } else {
      //console.log("login ", Util.getAuth());
      this.username = Util.getAuth().name;
      this.nameClient = Util.getClient().name;
    }
  },
};
/*beforeDestroy() {
      this.$eventHub.$off('focusTextSearch');
    },*/
/*mounted(){
      this.focusBusqueda
    }*/
</script>


<style scoped lang="scss">
@media (min-width: 700px) {
  .item-contenedor-busqueda {
    width: 500px;
    margin-left: 110px;
  }
  .field-busqueda {
    width: 500px;
  }
}

.has-text-filekom {
  color: #243c68;
}
</style>



// WEBPACK FOOTER //
// src/pages/Header.vue